// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter here
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        < Helmet >
            <title>B2B Admin</title>
        </Helmet >
        <Router>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </Router>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
